import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import {
  actions as userActions,
  asyncActions as userAsyncActions,
} from "../slices/userSlice.js";
import { asyncActions as successAsyncActions } from "../slices/successSlice.js";
import {
  actions as loginActions,
  asyncActions as loginAsyncActions,
} from "../slices/loginSlice.js";

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(userAsyncActions.getUserInfo.fulfilled),
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch;

    if (action.payload.items.length === 0) {
      dispatch(loginActions.logout());
    }
  },
});

listenerMiddleware.startListening({
  matcher: isAnyOf(userAsyncActions.updateCustomer.fulfilled),
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch;
    const result = JSON.parse(action.payload.P_RESULT);

    if (result.isSuccess === true) {
      dispatch(loginAsyncActions.checkCurrentVerificationStatus());
      await dispatch(userAsyncActions.getUserInfo());

      dispatch(
        successAsyncActions.showAsyncSuccess({
          msg: "profileSuccessfullyUpdated",
        })
      );
    }
  },
});

listenerMiddleware.startListening({
  actionCreator: userAsyncActions.connectCardAndCustomer.fulfilled,
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch;
    const result = JSON.parse(action.payload.P_RESULT);
    const setErrorMsg = action.meta.arg.setErrorMsg;

    if (result.isSuccess === true) {
      dispatch(
        successAsyncActions.showAsyncSuccess({
          msg: "physicalCardSuccesfullyConnected",
        })
      );
      dispatch(userAsyncActions.getUserInfo());
    } else {
      setErrorMsg(result.error);
    }
  },
});

listenerMiddleware.startListening({
  actionCreator: userAsyncActions.changePassword.fulfilled,
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch;
    const result = JSON.parse(action.payload.P_RESULT);
    const setErrorMsg = action.meta.arg.setErrorMsg;

    if (result.isSuccess === true) {
      dispatch(
        successAsyncActions.showAsyncSuccess({
          msg: "passwordChangeSuccess",
        })
      );
    } else {
      setErrorMsg(result.error);
    }
  },
});


listenerMiddleware.startListening({
  actionCreator: userAsyncActions.joinGiveaway.fulfilled,
  effect: async (action, listenerApi) => {
    const dispatch = listenerApi.dispatch;
    const result = JSON.parse(action.payload.P_RESULT);
    const setErrorMsg = action.meta.arg.setErrorMsg;
    const handleCloseModal = action.meta.arg.handleCloseModal;

    if (result.isSuccess === true) {
      dispatch(
        successAsyncActions.showAsyncSuccess({
          msg: "giveawaySuccessfullyJoined",
        })
      );
      dispatch(userAsyncActions.getUserInfo());
      handleCloseModal();
    } else {
      setErrorMsg(result.error);
    }
  },
});


export default listenerMiddleware;
